import axios from 'axios'
import { Loading, Message } from 'element-ui'
import router from '@/router'

// 全局 loading
let loadingInstance = null

const service = axios.create({
  baseURL: '/api',
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  }
})

// ==================== 请求拦截（核心：自动带 Token）====================
service.interceptors.request.use(
  config => {
    // 打开 loading
    loadingInstance = Loading.service({
      lock: true,
      text: '加载中...',
      background: 'rgba(0, 0, 0, 0.1)'
    })

    // 【关键】从 localStorage 取 token，塞进请求头
    const token = localStorage.getItem('infoToken')
    if (token) {
      // 后端接收写法：req.headers.token
     // config.headers['token'] = token  
      
      // 如果后端要的是：req.headers.authorization → 用下面这句
       config.headers['Authorization'] = 'Bearer ' + token
    }

    return config
  },
  error => {
    loadingInstance?.close()
    return Promise.reject(error)
  }
)

// ==================== 响应拦截 ====================
service.interceptors.response.use(
  (response) => {
    loadingInstance?.close();
    return response.data;
  },
  (error) => {
    loadingInstance?.close();

    const { status } = error.response || {};

    // 只有 token 过期、无效 才强制跳转登录
    // 登录接口的 401 不跳转！让页面自己处理
    if (status === 401) {
      const url = error.config.url;
      // 登录接口的 401，不跳转、不提示，直接返回给页面 catch
      if (url.includes('/user/login')) {
        return Promise.reject(error);
      }

      // 其他接口 401 → 才跳转登录
      Message.warning('登录已过期，请重新登录');
      localStorage.clear();
      window.location.href = '/login';
    } else {
      Message.error('网络异常或服务器错误');
    }

    return Promise.reject(error);
  }
);

export default service